import { isEmpty } from "lodash";

export function propsToInitialState(
  data,
  thucAnList,
  trangThaiSanXuatList,
  vungSanXuatList,
  loaiBenhHaiList,
  coSoCheBienList,
) {
  const dataInit = { ...data };
  dataInit.soLuongAoNuoi = data?.soLuongAoNuoi || null;
  dataInit.dienTichAoNuoi = data?.dienTichAoNuoi || null;
  dataInit.soLuongThaGiong = data?.soLuongThaGiong || null;
  dataInit.ngayThaGiong = data?.ngayThaGiong || null;
  dataInit.ngayDuBan = data?.ngayDuBan || null;
  dataInit.ngayBan = data?.ngayBan || null;
  dataInit.thucAns = data?.thucAn?.map(item =>
    thucAnList?.find(x => x?.id === item)
  );
  dataInit.trangThaiSX = trangThaiSanXuatList?.find(x => x?.id === data?.trangThaiSanXuat) || null;
  dataInit.vungSanXuats = data?.vungNuois?.map(item =>
    vungSanXuatList?.find(x => x?.id === item)
  );

  dataInit.benhHais = (!isEmpty(data?.lsBenhHai) &&
    data?.lsBenhHai?.map(item => ({
      loaiBenhHai: loaiBenhHaiList?.find(x => x?.id === item?.idBenhHai) || null,
      ngayPhatBenh: item?.ngayPhatBenh || null,
      ngayKetThuc: item?.ngayKetThuc || null,
      ghiChu: item?.ghiChu || null,
      ngaySuDung: item?.ngaySuDung || null,
      mucDichSuDung: item?.mucDichSuDung || null,
      lieuLuongSuDung: item?.lieuLuongSuDung || null
    }))) || [
    {
      loaiBenhHai: null
    }
  ];

  dataInit.thongTinBans = (!isEmpty(data?.thongTinBan) &&
    data?.thongTinBan?.map(item => ({
      coSoCheBien: coSoCheBienList?.find(x => x?.id === item?.idCoSoCheBien) || null,
      tenNguoiBan: item?.tenNguoiBan || null,
      soLuongBan: item?.soLuongBan || null,
      ngayBan: item?.ngayBan || null,
      ghiChu: item?.ghiChu || null
    }))) || [
    {
      coSoCheBien: null
    }
  ];

  return dataInit;
}

export function parseDataSave(value) {
  const dataSave = { ...value };
  dataSave.soLuongAoNuoi = value?.soLuongAoNuoi || 0;
  dataSave.dienTichAoNuoi = value?.dienTichAoNuoi || 0;
  dataSave.soLuongThaGiong = value?.soLuongThaGiong || 0;
  dataSave.ngayThaGiong = value?.ngayThaGiong || 0;
  dataSave.ngayDuBan = value?.ngayDuBan || 0;
  dataSave.ngayBan = value?.ngayBan || 0;
  dataSave.thucAn = value?.thucAns?.map(item => item?.id);
  dataSave.trangThaiSanXuat = value?.trangThaiSX?.id || 0;
  dataSave.vungNuois = value?.vungSanXuats?.map(item => item?.id);

  dataSave.lsBenhHai = [];
  value?.benhHais?.forEach(item => {
    dataSave.lsBenhHai.push({
      idBenhHai: item?.loaiBenhHai?.id || 0,
      ngayPhatBenh: item?.ngayPhatBenh || 0,
      ngayKetThuc: item?.ngayKetThuc || 0,
      ghiChu: item?.ghiChu,
      ngaySuDung: item?.ngaySuDung || 0,
      mucDichSuDung: item?.mucDichSuDung || null,
      lieuLuongSuDung: item?.lieuLuongSuDung || null
    });
  });

  dataSave.thongTinBan = [];
  value?.thongTinBans?.forEach(item => {
    dataSave.thongTinBan.push({
      idCoSoCheBien: item?.coSoCheBien?.id || 0,
      tenNguoiBan: item?.tenNguoiBan || null,
      soLuongBan: item?.soLuongBan || 0,
      ngayBan: item?.ngayBan || 0,
      ghiChu: item?.ghiChu
    });
  });

  return dataSave;
}
